export const PERFORMANCE_TABLE_COLUMNS = [
    {
        title: 'Campaign Name',
        sortable: false,
        key: 'campaignName',
        width: '12.5%',
    },
    {
        title: 'Ends on',
        sortable: true,
        key: 'endDate',
        width: '12.5%',
    },
    {
        title: 'Budget',
        sortable: true,
        key: 'budget',
        width: '12.5%',
    },
    {
        title: 'Spend',
        sortable: true,
        width: '12.5%',
        key: 'spend',
    },
    {
        title: 'Impressions',
        sortable: true,
        width: '12.5%',
        key: 'impressions',
    },
    {
        title: 'Cart Additions',
        sortable: true,
        width: '12.5%',
        key: 'add_to_cart',
    },
    {
        title: 'GMV',
        sortable: true,
        width: '12.5%',
        key: 'gmv',
    },
    {
        title: 'ROI',
        sortable: true,
        width: '12.5%',
        key: 'roi',
    },
];
export const PERFORMANCE_SUMMARY_TABLE_COLUMNS = [
    {
        title: 'Last Week',
        sortable: true,
        key: 'dateRange',
        width: '25%',
    },
    {
        title: 'Impressions',
        sortable: true,
        width: '25%',
        key: 'impressionCount',
    },
    {
        title: 'Cart Additions',
        sortable: true,
        width: '25%',
        key: 'addToCart',
    },
    {
        title: 'GMV',
        sortable: true,
        width: '25%',
        key: 'gmv',
    },
    {
        title: 'ROI',
        sortable: true,
        width: '25%',
        key: 'roi',
    },
];
